<template>
  <v-menu location="bottom" content-class="qtm-border">
    <template v-slot:activator="{ props }">
      <qtm-btn
        v-bind="props"
        tertiary
      >
        <v-icon class="mr-2">
          mdi-help-circle-outline
        </v-icon>
        Help
      </qtm-btn>
    </template>
    <v-list>
      <v-list-item @click="toggleFreshChat">
        <help-fresh-chat ref="fresh-chat" />
      </v-list-item>
      <v-list-item href="https://quotetome.freshdesk.com/support/home" target="_blank">
        <template v-slot:prepend>
          <v-icon>
            mdi-book-open-variant
          </v-icon>
        </template>
        <v-list-item-title>
          Visit Help Center
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script setup lang="ts">
import HelpFreshChat from '@/components/help-fresh-chat.vue'

const freshChatOpen = ref(false)
const freshChatRef = useTemplateRef<InstanceType<typeof HelpFreshChat>>('fresh-chat')

const toggleFreshChat = () => {
  if (freshChatOpen.value) {
    freshChatRef.value?.close()
    freshChatOpen.value = false
  }
  else {
    freshChatRef.value?.open()
    freshChatOpen.value = true
  }
}
</script>
